import React from 'react';
import { Box, Typography } from '@mui/material';

const RewardBadge = ({ icon, value, positive = true }) => {
    return (
        <Box
            sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                backgroundColor: '#B9E3FF',
                borderRadius: '8px',
                padding: '3px 14px',
                minWidth: '66px',
                pl: '24px',
                width: 'fit-content',
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    left: '-16px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    borderRadius: '50%',
                    width: '40px',
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                {icon}
            </Box>

            <Typography
                variant="body2"
                sx={{
                    fontSize: '14px',
                    color: positive ? '#0C3466' : 'red',
                    fontWeight: 600,
                }}
            >
                {value}
            </Typography>
        </Box>
    );
};

export default RewardBadge;
